import { PropsOf } from 'types';
import connect from './connect';
import SampleAudioLibrary from './SampleAudioLibrary';

export default connect(SampleAudioLibrary);

export type SampleAudioLibraryProps = PropsOf<ReturnType<typeof connect>>;
